import React from 'react';

const DetailModal = ({ isOpen, title, currentFeature, onCancel }) => (
  <div
    className={`modal fade ${isOpen && 'show'}`}
    style={{ display: isOpen ? 'block' : 'none', background: '#00000066' }}
    role="dialog"
  >
    <div className="modal-dialog" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{title}</h5>
          <button type="button" className="close" onClick={onCancel}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="feature-modal">
            <div className="pb-3">
              <h5>Name (TH)</h5>
              <span className="pl-3">{currentFeature?.nameTh || '-'}</span>
            </div>
            <div className="pb-3">
              <h5>Name (EN)</h5>
              <span className="pl-3">{currentFeature?.nameEn || '-'}</span>
            </div>
            <div className="pb-3">
              <h5>Name (JP)</h5>
              <span className="pl-3">{currentFeature?.nameJp || '-'}</span>
            </div>
            <div className="pb-3">
              <h5>Value</h5>
              <span className="pl-3">{currentFeature?.value || '-'}</span>
            </div>
            <div className="pb-3">
              <h5>Option</h5>
              <span className="pl-3">{currentFeature?.option || '-'}</span>
            </div>
            <div className="pb-3">
              <h5>Type</h5>
              <span className="pl-3">{currentFeature?.featureType || '-'}</span>
            </div>
            <div className="pb-3">
              <h5>Condition</h5>
              <span className="pl-3">{currentFeature?.condition || '-'}</span>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default DetailModal;
